module.exports = __webpack_public_path__ + "static/media/AdiPic.f3f96d88.png";